'use client';

import React from 'react';
import clsx from 'clsx';
import type { HTMLMotionProps, MotionValue } from 'framer-motion';
import { motion } from 'framer-motion';
import { getBorderColor } from 'theme-utils';
import type { ThemeColorsBorder } from '@frameio/vapor-theme';
import styles from './ScrollContainer.module.css';

export type ShadowSize = 'small' | 'medium';
type PlacementType = 'top' | 'bottom';

export type ShadowProps = {
  opacity: MotionValue<number>;
  offset?: number;
  enableShadow?: boolean;
  enableBorder?: boolean;
  borderColor?: ThemeColorsBorder;
  shadowSize?: ShadowSize;
  placement: PlacementType;
} & HTMLMotionProps<'div'>;

export function Shadow({
  opacity,
  offset = 0,
  enableShadow = true,
  enableBorder = false,
  borderColor = 'primary',
  shadowSize = 'medium',
  placement = 'top',
  className,
  style,
  ...other
}: ShadowProps) {
  const cssVars = {
    '--vapor-scroll-shadow-offset': `${offset}px`,
    '--vapor-scroll-shadow-border-color': getBorderColor(borderColor),
  } as React.CSSProperties;

  return (
    <motion.div
      className={clsx(styles.shadow, className)}
      data-enable-border={enableBorder || undefined}
      data-enable-shadow={enableShadow || undefined}
      data-placement={placement}
      data-shadow-size={shadowSize}
      style={{ ...cssVars, ...style, opacity }}
      {...other}
    />
  );
}
